export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10428.fdc1633b.jpg";